// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const Question = ({ fill, svgComponents: { G, Path, Rect } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Path d="M18.34,24.46a.78.78,0,0,1-.78-.76l0-1.28a4.13,4.13,0,0,1,2.7-4,3.64,3.64,0,0,0,2.38-3.53,2.62,2.62,0,0,0-2.77-2.39,2.77,2.77,0,0,0-1.81.86,2.33,2.33,0,0,0-.64,1.78.77.77,0,0,1-.72.83.76.76,0,0,1-.83-.72,3.87,3.87,0,0,1,1.05-3A4.28,4.28,0,0,1,19.72,11a4.17,4.17,0,0,1,4.43,3.82,5.15,5.15,0,0,1-3.37,5.09,2.56,2.56,0,0,0-1.7,2.46l0,1.32a.78.78,0,0,1-.76.79Z" />
            <Rect
                height="3.1"
                rx="1.55"
                ry="1.55"
                transform="translate(-1.99 1.46) rotate(-4.26)"
                width="3.1"
                x="17.13"
                y="25.94"
            />
            <Path d="M20,36A16,16,0,1,1,36,20,16,16,0,0,1,20,36ZM20,5A15,15,0,1,0,35,20,15,15,0,0,0,20,5Z" />
        </G>
    );
};

export default Question;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/question/index.js